import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutGrid, List, BarChart3, Trophy, Plus } from 'lucide-react';
import { isNavItemActive } from '@/components/app/navItems';

/**
 * Four tabs around a raised primary action.
 *
 * Instellingen staat hier niet: de avatar rechtsboven in de mobiele header
 * gaat er al heen, en die plek in de balk is meer waard voor het leaderboard.
 */
const LEFT_TABS = [
  { to: '/dashboard', label: 'Dashboard', icon: LayoutGrid },
  { to: '/rides', label: 'Ritten', icon: List },
];

const RIGHT_TABS = [
  { to: '/statistieken', label: 'Statistieken', icon: BarChart3 },
  { to: '/leaderboard', label: 'Leaderboard', icon: Trophy },
];

function Tab({ to, label, icon: Icon, active }) {
  return (
    <Link
      to={to}
      aria-current={active ? 'page' : undefined}
      data-testid={`bottom-nav-${to.slice(1)}`}
      className={`flex flex-col items-center justify-center gap-1 h-[58px] transition-colors ${
        active ? 'text-dd-lime' : 'text-dd-dim'
      }`}
    >
      <Icon className="w-[22px] h-[22px]" strokeWidth={active ? 2.2 : 1.8} />
      <span className="text-[10px] font-medium leading-none">{label}</span>
    </Link>
  );
}

export default function BottomNav() {
  const location = useLocation();

  return (
    <nav
      data-testid="bottom-nav"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-dd-s1 border-t border-dd-line pb-[env(safe-area-inset-bottom)]"
    >
      <div className="grid grid-cols-5 items-center">
        {LEFT_TABS.map((tab) => (
          <Tab key={tab.to} {...tab} active={isNavItemActive(location.pathname, tab.to)} />
        ))}

        {/* Raised primary action — the reason the bar has five columns. */}
        <div className="flex justify-center">
          <Link
            to="/rides/add"
            aria-label="Rit toevoegen"
            data-testid="bottom-nav-add-ride"
            className="-mt-6 w-14 h-14 rounded-full bg-dd-lime text-dd-bg flex items-center justify-center border-4 border-dd-bg dd-glow-soft active:bg-dd-lime-dim transition-colors"
          >
            <Plus className="w-6 h-6" strokeWidth={2.6} />
          </Link>
        </div>

        {RIGHT_TABS.map((tab) => (
          <Tab key={tab.to} {...tab} active={isNavItemActive(location.pathname, tab.to)} />
        ))}
      </div>
    </nav>
  );
}
